import client from "../client";

export interface UploadRequest {
  file: any;
}

export interface UploadResponse {
  errorMessage?: string | null;
  result?: UploadImageResult[];
}

export interface UploadImageResult {
  url?: string | null;
  name?: string | null;
  size?: string | null;
}

export default function Upload(
  request: UploadRequest
): Promise<UploadResponse> {
  const file = request.file;
  let data = new FormData();
  data.append("file-0", file, file.fileNmae);
  return client
    .post(`upload/image`, data)
    .then((response) => response.data)
    .then((json) => {
      return json;
    });
}
